module.exports = function (p15623) {
  return function () {
    function f2095(p15624, p15625) {
      return p15624.distance - p15625.distance;
    }
    function f2096(p15626, p15627, p15628, p15629) {
      if (p15626.visible !== false && (p15626.raycast(p15627, p15628), p15629 === true)) {
        const v12617 = p15626.children;
        for (let vLN02255 = 0, v12618 = v12617.length; vLN02255 < v12618; vLN02255++) {
          f2096(v12617[vLN02255], p15627, p15628, true);
        }
      }
    }
    p15623.Raycaster2 = class {
      constructor(p15630, p15631, p15632 = 0, p15633 = Infinity) {
        this.ray = new p15623.Ray(p15630, p15631);
        this.near = p15632;
        this.far = p15633;
        this.camera = null;
        this.layers = new p15623.Layers();
        this.params = {
          Mesh: {},
          Line: {
            threshold: 1
          },
          LOD: {},
          Points: {
            threshold: 1
          },
          Sprite: {}
        };
      }
      set(p15634, p15635) {
        this.ray.set(p15634, p15635);
      }
      setFromCamera(p15636, p15637) {
        if (p15637 && p15637.isPerspectiveCamera) {
          this.ray.origin.setFromMatrixPosition(p15637.matrixWorld);
          this.ray.direction.set(p15636.x, p15636.y, 0.5).unproject(p15637).sub(this.ray.origin).normalize();
          this.camera = p15637;
        } else if (p15637 && p15637.isOrthographicCamera) {
          this.ray.origin.set(p15636.x, p15636.y, (p15637.near + p15637.far) / (p15637.near - p15637.far)).unproject(p15637);
          this.ray.direction.set(0, 0, -1).transformDirection(p15637.matrixWorld);
          this.camera = p15637;
        } else {
          console.error("THREE.Raycaster: Unsupported camera type: " + p15637.type);
        }
      }
      intersectObject(p15638, p15639 = true, p15640 = []) {
        f2096(p15638, this, p15640, p15639);
        p15640.sort(f2095);
        return p15640;
      }
      intersectObjects(p15641, p15642 = true, p15643 = []) {
        for (let vLN02256 = 0, v12619 = p15641.length; vLN02256 < v12619; vLN02256++) {
          f2096(p15641[vLN02256], this, p15643, p15642);
        }
        p15643.sort(f2095);
        return p15643;
      }
    };
  }();
};